import { fetchWithAuth } from '../redux/auth/authService';

/**
 * A wrapper around fetchWithAuth that mimics the Axios interface
 * used by some slices (like trainerSlice).
 */
const api = {
  get: async (url, options = {}) => {
    const response = await fetchWithAuth(url, {
      ...options,
      method: 'GET',
    });
    return { data: response }; // Return the normalized response object as 'data'
  },

  post: async (url, body, options = {}) => {
    const isFormData = body instanceof FormData;
    const response = await fetchWithAuth(url, {
      ...options,
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
    });
    return { data: response };
  },

  put: async (url, body, options = {}) => {
    const isFormData = body instanceof FormData;
    const response = await fetchWithAuth(url, {
      ...options,
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
    });
    return { data: response };
  },

  delete: async (url, options = {}) => {
    const response = await fetchWithAuth(url, {
      ...options,
      method: 'DELETE',
    });
    return { data: response };
  },
};

export default api;
